import { createRouter, createWebHistory } from 'vue-router'

import Home from '@/pages/Home.vue'
import NotFound from '@/pages/NotFound.vue'

const modules = import.meta.glob('../experiments/**/App.vue')

const experimentRoutes = Object.keys(modules).map(filePath => {
  // Example filePath: '../experiments/ExperimentA/Experiment.vue'

  // Extract the folder name "ExperimentA"
  const parts = filePath.split('/')
  const folderName = parts[parts.length - 2]

  // Convert PascalCase → kebab-case
  const name = folderName
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()

  return {
    path: `/experiments/${name}`,
    component: modules[filePath]
  }
})

const routes = [
  { path: '/', component: Home },
  ...experimentRoutes,
  { path: '/:catchAll(.*)', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
